export const aboutContent = {
  en: {
    title: "About Industrial Hemp Cultivation",
    subtitle: "Comprehensive Safety & Compliance Standards",
    purpose: {
      title: "Our Purpose",
      content: "This SOP establishes comprehensive, TRHP-aligned procedures for safe, compliant industrial hemp cultivation and export. It includes integrated training modules, simulation exercises, visual aids, and process checklists to ensure every team member thoroughly understands the workflow from licensing through continuous improvement."
    },
    scope: {
      title: "Scope of Operations",
      content: "This document applies to all personnel, field operations, training sessions, and assessments at [Farm Name] and its satellite rural hemp sites under the Thai Rural Hemp Projects (TRHP)."
    },
    responsibilities: {
      title: "Key Responsibilities",
      content: "Our structured approach ensures clear roles and responsibilities across all levels of operation, from farm management to field technicians and quality assurance teams."
    },
    coreProcedures: {
      title: "Core Procedures Overview",
      items: [
        {
          title: "Licensing & Certification",
          description: "Obtain and maintain valid cultivation/export licenses from Thai FDA and GACP certification programs."
        },
        {
          title: "Site Preparation & Planting",
          description: "Verify land titles, perform soil tests, and plant certified non-GMO seeds with proper handling training."
        },
        {
          title: "Cultivation & Maintenance",
          description: "Monitor irrigation, apply organic fertilizers, and employ biological pest controls with documentation."
        },
        {
          title: "Harvest & Post-Harvest",
          description: "Determine harvest readiness, sanitize equipment, and maintain controlled drying conditions with accurate labeling."
        },
        {
          title: "Export Logistics",
          description: "Secure required certificates, ensure proper labeling, and coordinate with certified freight forwarders."
        }
      ]
    }
  },
  th: {
    title: "เกี่ยวกับการปลูกกัญชงอุตสาหกรรม",
    subtitle: "มาตรฐานความปลอดภัยและการปฏิบัติตามข้อกำหนดอย่างครอบคลุม",
    purpose: {
      title: "วัตถุประสงค์ของเรา",
      content: "SOP นี้กำหนดขั้ procedures อย่างครอบคลุมตาม TRHP สำหรับการปลูกและการส่งออกกัญชงอุตสาหกรรมอย่างปลอดภัยและปฏิบัติตามข้อกำหนด รวมถึงโมดูลการฝึกอบรมแบบรวมเข้าด้วยกัน การจำลองแบบฝึกซ้อม ภาพประกอบ และรายการตรวจสอบกระบวนการ เพื่อให้สมาชิกทีมทุกคนเข้าใจอย่างถ่องแท้ถึงขั้นตอนการทำงานตั้งแต่การขอใบอนุญาตจนถึงการปรับปรุงอย่างต่อเนื่อง"
    },
    scope: {
      title: "ขอบเขตของการดำเนินงาน",
      content: "เอกสารนี้ใช้บังคับกับบุคลากร การดำเนินงานในสนาม เซสชั่นการฝึกอบรม และการประเมินผลทั้งหมดที่ [ชื่อฟาร์ม] และไซต์กัญชงในชนบทที่เป็นดาวเทียมภายใต้โครงการกัญชงในชนบทไทย (TRHP)"
    },
    responsibilities: {
      title: "ความรับผิดชอบหลัก",
      content: "แนวทางที่มีโครงสร้างของเราช่วยให้แน่ใจว่ามีบทบาทและความรับผิดชอบที่ชัดเจนในทุกระดับของการดำเนินงาน ตั้งแต่การจัดการฟาร์มไปจนถึงช่างเทคนิคในสนามและทีมประกันคุณภาพ"
    },
    coreProcedures: {
      title: "ภาพรวมขั้cedures หลัก",
      items: [
        {
          title: "การขอใบอนุญาตและการรับรอง",
          description: "ขอและรักษาใบอนุญาตการปลูก/การส่งออกที่ถูกต้องจาก FDA ไทยและโปรแกรมการรับรอง GACP"
        },
        {
          title: "การเตรียมไซต์และการปลูก",
          description: "ตรวจสอบกรรมสิทธิ์ที่ดิน ทำการทดสอบดิน และปลูกเมล็ดพันธุ์ GMO ที่ได้รับการรับรองด้วยการฝึกอบรมการจัดการที่เหมาะสม"
        },
        {
          title: "การปลูกและการบำรุงรักษา",
          description: "ตรวจสอบระบบการให้น้ำ ใช้ปุ๋ยอินทรีย์ และใช้การควบคุมแมลงศัตรูพืชทางชีวภาพพร้อมการบันทึกเอกสาร"
        },
        {
          title: "การเก็บเกี่ยวและการหลังเก็บเกี่ยว",
          description: "กำหนดความพร้อมในการเก็บเกี่ยว ฆ่าเชื้อเครื่องมือ และรักษาสภาวะการอบแห้งที่ควบคุมได้พร้อมการติดฉลากที่ถูกต้อง"
        },
        {
          title: "โลจิสติกส์การส่งออก",
          description: "รับรองใบรับรองที่จำเป็น รับประกันการติดฉลากที่เหมาะสม และประสานงานกับผู้ส่งของที่ได้รับการรับรอง"
        }
      ]
    }
  }
};
